import { SvgIcon } from '@mui/material';
import React from 'react';

export default function InteriorIcon({ ...props }) {
  return (
    <SvgIcon
      fill="none"
      height="16"
      viewBox="0 0 17 16"
      width="17"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M8.02596 0C5.89805 0.0023015 3.85795 0.84863 2.35329 2.35329C0.84863 3.85795 0.0023015 5.89805 0 8.02596C0.401298 18.6604 15.6506 18.6557 16.0519 8.02596C16.0496 5.89805 15.2033 3.85795 13.6986 2.35329C12.194 0.84863 10.1539 0.0023015 8.02596 0ZM8.02596 2.00649C9.21374 2.00763 10.3747 2.35968 11.3631 3.01843C12.3514 3.67718 13.1231 4.61326 13.5813 5.70913L9.37967 6.54985C8.45466 6.73445 7.50229 6.73445 6.57727 6.54985L2.4633 5.72652C2.91932 4.6263 3.69102 3.68581 4.68103 3.02374C5.67104 2.36167 6.83497 2.0077 8.02596 2.00649ZM2.0105 8.23129L4.11999 8.65332C4.50506 8.73035 4.86845 8.89121 5.18436 9.12447C5.50027 9.35773 5.76095 9.65768 5.9479 10.003L6.36592 10.7742C6.57696 11.1645 6.68773 11.6012 6.6883 12.045V13.8929C5.39405 13.5959 4.23403 12.8799 3.38823 11.8563C2.54243 10.8326 2.05814 9.55834 2.0105 8.23129ZM9.36362 13.8956V12.0476C9.36419 11.6039 9.47496 11.1672 9.686 10.7769L10.104 10.0057C10.291 9.66036 10.5517 9.36041 10.8676 9.12715C11.1835 8.89388 11.5469 8.73303 11.9319 8.656L14.0414 8.23397C13.9938 9.56101 13.5095 10.8352 12.6637 11.8589C11.8179 12.8826 10.6579 13.5985 9.36362 13.8956Z" />
    </SvgIcon>
  );
}
